module.exports = __webpack_public_path__ + "static/media/TOWER Wevsure - Middle - main - 23 Dec 2022.3804989c.svg";